import {Injectable} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TabStateEnum} from '../types/site.type';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  private currentTabControl: FormControl = new FormControl('my-sites');
  private currentPageControl: FormControl = new FormControl(1);
  private searchControl: FormControl = new FormControl('');

  get defaultPageSize() {
    return [10, 25, 50];
  }

  get currentPage() {
    return this.currentPageControl.value;
  }

  set currentPage(page: number) {
    this.currentPageControl.setValue(page);
  }

  get currentTab() {
    return this.currentTabControl.value;
  }

  set currentTab(tab: TabStateEnum) {
    this.currentTabControl.setValue(tab);
  }

  get searchString() {
    return this.searchControl.value;
  }

  set searchString(value: string) {
    this.searchControl.setValue(value);
  }

  getQueryParams() {
    return this.searchString
      ? {
          search: this.searchString,
        }
      : {};
  }

  resetFilters() {
    this.searchString = null;
  }
}
